import Helper from '@ember/component/helper';
import { ActionType } from 'cio/models/action';
import info from 'cio/utils/action-info';

export function actionInfo([actionType]: [ActionType]) {
  return info(actionType);
}

export default Helper.helper(actionInfo);
